module.exports = __webpack_public_path__ + "img/sv82.83dc22b9.svg";